import React, { useState, useEffect } from 'react';

const FeedbackForm = ({ isPremium, state, lines }) => {
    const [suggestion, setSuggestion] = useState('');
    const [buttonText, setButtonText] = useState('Enviar feedback anònim');
    const [techDetails, setTechDetails] = useState({});

    useEffect(() => {
        // Gather technical details when component mounts
        gatherTechDetails();
    }, []);

    const gatherTechDetails = () => {
        const details = {
            userAgent: navigator.userAgent,
            platform: navigator.platform,
            vendor: navigator.vendor,
            language: navigator.language,
            screenWidth: window.screen.width,
            screenHeight: window.screen.height,
            devicePixelRatio: window.devicePixelRatio || 1,
            isMobile: /Mobi|Android/i.test(navigator.userAgent),
            isDesktop: !/Mobi|Android/i.test(navigator.userAgent),
            isMacOS: /Mac/i.test(navigator.platform),
            isWindows: /Win/i.test(navigator.platform),
            isLinux: /Linux/i.test(navigator.platform),
            browserName: getBrowserName(),
            hasGPU: hasGPUSupport(),
            memoryInfo: getMemoryInfo(),
            connectionType: getConnectionInfo(),
            timestamp: new Date().toISOString()
        };
        
        setTechDetails(details);
    };

    const getBrowserName = () => {
        const userAgent = navigator.userAgent;
        let browserName;
        
        if (userAgent.match(/chrome|chromium|crios/i)) {
            browserName = "Chrome";
        } else if (userAgent.match(/firefox|fxios/i)) {
            browserName = "Firefox";
        } else if (userAgent.match(/safari/i)) {
            browserName = "Safari";
        } else if (userAgent.match(/opr\//i)) {
            browserName = "Opera";
        } else if (userAgent.match(/edg/i)) {
            browserName = "Edge";
        } else {
            browserName = "Unknown";
        }
        
        return browserName;
    };

    const hasGPUSupport = () => {
        // Basic GPU detection
        const canvas = document.createElement('canvas');
        const gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
        
        if (!gl) {
            return false;
        }
        
        const debugInfo = gl.getExtension('WEBGL_debug_renderer_info');
        if (debugInfo) {
            return {
                vendor: gl.getParameter(debugInfo.UNMASKED_VENDOR_WEBGL),
                renderer: gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL)
            };
        }
        
        return true;
    };

    const getMemoryInfo = () => {
        if (navigator.deviceMemory) {
            return { deviceMemory: navigator.deviceMemory + 'GB' };
        }
        return 'Not available';
    };

    const getConnectionInfo = () => {
        if (navigator.connection) {
            const connection = navigator.connection;
            return {
                effectiveType: connection.effectiveType,
                downlink: connection.downlink,
                rtt: connection.rtt,
                saveData: connection.saveData
            };
        }
        return 'Not available';
    };

    const sendEmail = async () => {
        if (suggestion !== "") {
            const url = atob("aHR0cHM6Ly9hb2hzNGRncng0LmV4ZWN1dGUtYXBpLmV1LXdlc3QtMy5hbWF6b25hd3MuY29tL1N0YWdlL1NlbmRTdWdnZXN0aW9uVmlhRW1haWxQeXRob24=");
            const api_key = atob("Y0ttajZmajU3RzJ5b3JmVXVhdndoajQwUHBMV3poYzhRNm03");

            try {
                setSuggestion('');
                setButtonText('Enviat!');

                // Create a complex message object with all details
                const complexMessage = {
                    userSuggestion: suggestion,
                    appState: state,
                    technicalDetails: techDetails,
                    outputLines: Array.isArray(lines) ? lines.slice(-10) : [], // Last 10 lines
                    isPremiumUser: isPremium
                };

                await fetch(url, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'x-api-key': api_key
                    },
                    body: JSON.stringify({ message: JSON.stringify(complexMessage) })
                });

                setTimeout(() => setButtonText('Enviar feedback anònim'), 2000);
            } catch (error) {
                console.error('Error sending feedback:', error);
            }
        }
    };

    return (
        <div style={{ backgroundColor: '#f2f2f2', padding: '20px', marginTop: '20px', borderRadius: '5px' }}>
            <h4>Volem el teu feedback!</h4>
            <textarea
                id="suggestionBox"
                placeholder="Tens suggerències? Què és el que més et molesta? Si us plau, dona'ns feedback per poder millorar l'aplicatiu..."
                style={{ marginTop: 0, width: '95%', height: '50px', marginBottom: '10px', padding: '10px', borderRadius: '5px', border: '1px solid #ccc', fontSize: '12px' }}
                value={suggestion}
                onChange={e => setSuggestion(e.target.value)}
            />
            <button
                id="sendSuggestion"
                onClick={sendEmail}
                style={{ backgroundColor: !isPremium ? '#4CAF50' : '#b95fdd', color: 'white', padding: '8px 16px', textAlign: 'center', textDecoration: 'none', display: 'inline-block', fontSize: '12px', margin: '4px 2px', cursor: 'pointer' }}
            >
                {buttonText}
            </button>
        </div>
    );
};

export default FeedbackForm;